import React from 'react';
import { ITrackPackageResponse } from '../../../models/trackPage/trackPackage.model';
import { RedBorderButton } from '../../../components/Button/Buttons';
import styled from '@emotion/styled';
import { DownloadOutlined } from '@ant-design/icons';
// import useDownloadPDF from '../../../hooks/quote/useDownloadPdf';
// import usePrint from '../../../hooks/quote/usePrint';
// import ProofOfDelivery from './ProofOfDelivery';
import { PDFDownloadLink } from "@react-pdf/renderer";
import ReceiptPdf from './ReceiptPDF';

interface IPackageDetails {
  trackingInfo?: ITrackPackageResponse;
}

const DownloadProofOfDelivery: React.FC<IPackageDetails> = ({
  trackingInfo,
}) => {
  // const { contentRef } = usePrint();
  const [signatureBase64, setSignatureBase64] = React.useState<string>('');

  React.useEffect(() => {
    const url = trackingInfo?.signatureUrl;
    if (!url) return;

    fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.onload = () => setSignatureBase64(reader.result as string);
        // Force PNG MIME type since the URL has no extension
        const typed = new Blob([blob], { type: 'image/png' });
        reader.readAsDataURL(typed);
      })
      .catch(() => setSignatureBase64(''));
  }, [trackingInfo?.signatureUrl]);


  const receiptProps = {
    itemId: trackingInfo?.packageId || '',
    shipmentId: trackingInfo?.packageId || '',
    name: trackingInfo?.receiverName || '',
    address: trackingInfo?.address || '',
    date: trackingInfo?.scheduledDeliveryDate || '',
    signature: signatureBase64 || undefined,
  };


  if (trackingInfo?.shippingStatus !== 'DELIVERED') {
    return null;
  }


  return (
    <Container>
      <PDFDownloadLink
        document={<ReceiptPdf {...receiptProps} />}
        fileName={`${trackingInfo?.packageId}_proof-of-delivery.pdf`}
        style={{ textDecoration: 'none' }}
      >
        {({ loading }) => (
          <RedBorderButton disabled={loading}>
            <DownloadOutlined />{' '}
            {loading ? 'Downloading...' : 'Proof of Delivery'}
          </RedBorderButton>
        )}
      </PDFDownloadLink>



      {/* <RedBorderButton onClick={downloadPDF} disabled={isDownloading}>
        <DownloadOutlined />{' '}
        {isDownloading ? 'Downloading...' : 'Proof of Delivery'}
      </RedBorderButton>
      <PdfWrapper>
        <div ref={contentRef}>
          <ProofOfDelivery trackingInfo={trackingInfo} />
        </div>
      </PdfWrapper> */}
    </Container>
  );
};

export default DownloadProofOfDelivery;

const Container = styled.div`
 position: relative;
 padding: 24px 0;
 display: flex;
 align-items: center;
 justify-content: center;
`;

// const PdfWrapper = styled.div`
//  position: absolute;
//  display: flex;
//  flex-direction: column;
//  align-items: center;
//  justify-content: center;
//  z-index: -10;
//  opacity: 0;
//  transform: translateY(-200%);
// `;
